<template>
  <div class="def-show-more" @click="$emit('update:modelValue', !modelValue)">
    <DefCirclePlus :result="modelValue" />
    <slot v-if="modelValue" name="less" />
    <slot v-else />
  </div>
</template>

<script>
import DefCirclePlus from '@components/Def/DefCirclePlus/DefCirclePlus.vue';

export default {
  name: 'DefShowMore',
  components: { DefCirclePlus },
  props: ['modelValue'],
};
</script>

<style lang="scss" scoped>
.def-show-more {
  display: flex;
  align-items: center;
  margin-right: 4px;
  color: var(--color-golden-browm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  &__icon {
    display: block;
    fill: currentColor;
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
  :deep(.def-show-more) {
  }

  :deep(.def-circle-plus) {
    margin-right: 6px;
  }
}
</style>
